import React, {Component} from 'react';
import {
  StyleSheet,
  Text,
  View,
  Image,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import PropTypes from 'prop-types';
import colors from '../HelperClasses/AppColor';
import tableStyle from '../StyleSheets/TableCommonStyleSheet';
import {Gradient} from 'react-gradient';
import {ReactComponent as LockIcon} from '../assets/lockWhite.svg';
import LocaleContext from '../Localization/LocaleContext';

export default class CommonSaveButton extends Component {
  static propTypes = {
    saveBtn: PropTypes.func,
    saveBtnTitle: PropTypes.node,
    showSaveBtn: PropTypes.bool,
    btnDeActive: PropTypes.bool,
    deActiveBtnAction: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  renderActiveBtn = ({translate = key => key} = {}) => {
    let saveTitle =
      this.props.saveBtnTitle == undefined ? 'Save' : this.props.saveBtnTitle;
    if (typeof saveTitle === 'string') saveTitle = translate(saveTitle);
    if (this.props.showSaveBtn == undefined || this.props.showSaveBtn == true) {
      return (
        <View>
          <View style={[tableStyle.gradientViewBGStyle, {marginRight: 0}]}>
            <Gradient
              gradients={colors.GradientColors} // required
              property="background"
              gradientType={'linear'}
              duration={2333000}
              angle="0deg">
              <TouchableOpacity onPress={this.props.saveBtn}>
                <Text style={tableStyle.saveBtnTxtStyle}>{saveTitle}</Text>
              </TouchableOpacity>
            </Gradient>
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderDeActiveBtn = ({translate = key => key} = {}) => {
    let saveTitle =
      this.props.saveBtnTitle == undefined ? 'Save' : this.props.saveBtnTitle;
    if (typeof saveTitle === 'string') saveTitle = translate(saveTitle);
    if (this.props.showSaveBtn == undefined || this.props.showSaveBtn == true) {
      return (
        <View>
          <View style={[tableStyle.gradientViewBGStyle, {margin: 0}]}>
            <Gradient
              gradients={colors.GradientGrayColors} // required
              property="background"
              gradientType={'linear'}
              duration={2333000}
              angle="0deg">
              <TouchableOpacity
                style={{flexDirection: 'row', alignItems: 'center'}}
                onPress={this.props.deActiveBtnAction}>
                <LockIcon
                  stroke={colors.AppWhite}
                  style={{height: 16, width: 16, marginLeft: 8}}
                />
                <Text style={tableStyle.saveBtnTxtStyle}>{saveTitle}</Text>
              </TouchableOpacity>
            </Gradient>
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };
  render() {
    return (
      <LocaleContext.Consumer>
        {localeContext => this.props.btnDeActive == true
          ? <this.renderDeActiveBtn translate={localeContext?.translate} />
          : <this.renderActiveBtn translate={localeContext?.translate} />}
      </LocaleContext.Consumer>
    );
  }
}
